(function(){
  "use strict";

  angular.module('irricrops')
    .controller("vinedoProdResCtrl", ["$scope","MultiChart","Config","$timeout",
      function( $scope, MultiChart, Config, $timeout){

        $scope.search = {};


        $scope.activeItemList = function(item){
          // $scope.setItemSelectedNull();
          item.active = true;
          $scope.itemSelected = item;
          $timeout(function(){
            $(".backdrop-list").height($("#content")[0].scrollHeight);
          }, 1500);
        };

        $scope.setItemSelectedNull = function(){
          $scope.itemSelected = null;
          angular.forEach($scope.cuarteles, function(cuartel) {
            cuartel.active = false;
          });
        };

        $scope.cuarteles = [
        {
          cuartel: 1,
          nombre: "Cuartel 1",

          porcentaje_reposicion: 23,
          metros_hectareas: 234,
          peso_poda_metro: 0.3,
          produccion_toneladas_ha: 3.23,
          porcentaje_N: 0.2,
          unidad_N: 2,
          vigor: "vigoroso",
          historico:{
            2011:{
              porcentaje_reposicion: 23,
              metros_hectareas: 4340,
              peso_poda_metro: 0.3,
              produccion_toneladas_ha: 3123,
              porcentaje_N: 0.15,
              unidad_N: 2.3,
              vigor: "vigoroso",
            },
          2012:{
            porcentaje_reposicion: 26,
            metros_hectareas: 3040,
            peso_poda_metro: 0.4,
            produccion_toneladas_ha: 2534,
            porcentaje_N: 0.17,
            unidad_N: 1.5,
            vigor: "vigoroso",
          },
          2013:{
            porcentaje_reposicion: 19,
            metros_hectareas: 2940,
            peso_poda_metro: 0.3,
            produccion_toneladas_ha: 3212,
            porcentaje_N: 0.16,
            unidad_N: 1.8,
            vigor: "vigoroso",
          },
          2014:{
            porcentaje_reposicion: 17,
            metros_hectareas: 2340,
            peso_poda_metro: 0.3,
            produccion_toneladas_ha: 2765,
            porcentaje_N: 0.24,
            unidad_N: 2.3,
            vigor: "vigoroso",
          },

          2015:{
            porcentaje_reposicion: 20,
            metros_hectareas: 3340,
            peso_poda_metro: 0.3,
            produccion_toneladas_ha: 2980,
            porcentaje_N: 0.22,
            unidad_N: 2.5,
            vigor: "vigoroso",
          },
          2016:{
            porcentaje_reposicion: 23,
            metros_hectareas: 4340,
            peso_poda_metro: 0.3,
            produccion_toneladas_ha: 3123,
            porcentaje_N: 0.20,
            unidad_N: 2.3,
            vigor: "vigoroso",
          }

          },


            yemas_ha: "50.000",
            brotes_ha: "47.500",
            rac_ha: "6.175",
            kg_ha: "6.175",
            hectareas: "45",
            clon: "214",
            plantas_ha: "6.354",
            variedad: "Merlot",
            conduccion: "Parron",
            plantasTotal: "64.354",
            entreHilera: "1.5",
            sobreHilera: "1.5",
            mtsLineales: "6.244",
            brotReal: true

        },
      ];

      //para poblar lista
      for (var i = 2; i < 10; i++) {
        c = angular.copy($scope.cuarteles[0]);
        c.cuartel = i;
        $scope.cuarteles.push(c);
      }




        var startMultiChart = function() {


          angular.forEach($scope.cuarteles, function(cuartel, key) {
            cuartel.nombre = "Cuartel "+cuartel.cuartel;

            cuartel.h = new MultiChart("Comparación de temporadas");

            var reposicion = [];
            var metros_hectareas = [];
            var peso_poda_metro = [];
            var produccion_toneladas_ha = [];
            var porcentaje_N = [];
            var unidad_N = [];

            angular.forEach(cuartel.historico, function (val, k) {
              k = moment("01-01-"+k).unix()*1000;
              reposicion.push([k, parseFloat(val.porcentaje_reposicion)]);
              metros_hectareas.push([k, parseFloat(val.metros_hectareas)]);
              peso_poda_metro.push([k, parseFloat(val.peso_poda_metro)]);
              produccion_toneladas_ha.push([k, parseFloat(val.produccion_toneladas_ha)]);
              porcentaje_N.push([k, parseFloat(val.porcentaje_N)]);
              unidad_N.push([k, parseFloat(val.unidad_N)]);
            });

            cuartel.h.agregarSerie({
               color: Config.colors.unidad_n.background,
                name: 'Unidad Nitrogeno',
                yAxis: 5,
                type:'column',
                suffix: ' kg',
                data: unidad_N
              });


            cuartel.h.agregarSerie({
               color: Config.colors.metros_hectareas.background,
                name: 'm<sup>3</sup> / ha',
                yAxis: 7,
                type:'column',
                suffix: ' mts/ha',
                data: metros_hectareas
              });

            cuartel.h.agregarSerie({
               color: Config.colors.peso_poda_metro.background,
                name: 'Peso Poda kg/mt',
                yAxis: 5,
                type:'column',
                suffix: ' Kg/mt',
                data: peso_poda_metro
              });

            cuartel.h.agregarSerie({
               color: Config.colors.produccion_toneladas_ha.background,
                name: 'Producción ton/ha',
                yAxis: 6,
                type:'column',
                suffix: ' Ton/ha',
                data: produccion_toneladas_ha
              });

            cuartel.h.agregarSerie({
              color: Config.colors.porcentaje_reposicion.background,
              name: '% de Reposicion',
              yAxis: 4,
              suffix: ' %',
              data:reposicion
            });

            cuartel.h.agregarSerie({
              color: Config.colors.porcentaje_n.background,
              name: '% de Nitrogeno',
              yAxis: 4,
              suffix: ' %',
              data:porcentaje_N
            });



            cuartel.HMChartConfig = cuartel.h.getConfig();

          });
        };
        startMultiChart();
      }]);


})();
